import { Controller } from '@hotwired/stimulus'
import { gsap, Sine } from 'gsap'

import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)

export default class extends Controller {
  initialize() {
    this.initializeAnimations = this.initializeAnimations.bind(this)
    super.initialize()
  }

  connect() {
    this.resetElementState()
    requestAnimationFrame(this.initializeAnimations)

    super.connect()
  }

  disconnect() {
    this.cleanup()
    super.disconnect()
  }

  resetElementState() {
    document.querySelectorAll('.title-hero, .headline-hero, .hero-image-item').forEach(el => {
      el.style.opacity = '1'
      el.style.visibility = 'visible'
      el.style.display = ''
    })
  }

  cleanup() {
    gsap.killTweensOf('.title-hero')
    gsap.killTweensOf('.headline-hero')

    gsap.utils
      .toArray('.hero-image-item')
      .forEach(can => gsap.killTweensOf(can))

    ScrollTrigger.getAll().forEach(trigger => trigger.kill())
  }

  initializeAnimations() {
    this.cleanup()

    // Force all elements to be visible first
    gsap.set(['.title-hero', '.headline-hero', '.hero-image-item'], {
      clearProps: "all",
      opacity: 1,
      visibility: "visible"
    })

    // Check if elements exist before animating
    const titleHero = document.querySelector('.title-hero')
    const headlineHero = document.querySelector('.headline-hero')

    if (titleHero) {
      gsap.fromTo(titleHero,
        { y: 50, opacity: 0 },
        { y: 0, duration: 0.5, opacity: 1 }
      )
    }

    if (headlineHero) {
      gsap.fromTo(headlineHero,
        { y: 25, opacity: 0 },
        { y: 0, duration: 0.25, opacity: 1, delay: 0.25 }
      )
    }

    const randomX = this.random(1, 10)
    const randomY = this.random(1, 10)
    const randomTime = this.random(3, 5)
    const randomTime2 = this.random(5, 10)
    const randomAngle = this.random(-10, 10)

    gsap.utils.toArray('.hero-image-item').forEach(can => {
      gsap.set(can, {
        clearProps: "all",
        x: randomX(-1),
        y: randomX(1),
        rotation: randomAngle(-1),
        opacity: 1,
        visibility: "visible"
      })

      this.moveX(can, 1, randomX, randomTime)
      this.moveY(can, -1, randomY, randomTime)
      this.rotate(can, 1, randomAngle, randomTime2)
    })
  }

  rotate(target, direction, randomAngle, randomTime2) {
    gsap.to(target, randomTime2(), {
      rotation: randomAngle(direction),
      ease: Sine.easeInOut,
      onComplete: this.rotate.bind(this),
      onCompleteParams: [target, direction * -1, randomAngle, randomTime2],
    })
  }

  moveX(target, direction, randomX, randomTime) {
    gsap.to(target, randomTime(), {
      x: randomX(direction),
      ease: Sine.easeInOut,
      onComplete: this.moveX.bind(this),
      onCompleteParams: [target, direction * -1, randomX, randomTime],
    })
  }

  moveY(target, direction, randomY, randomTime) {
    gsap.to(target, randomTime(), {
      y: randomY(direction),
      ease: Sine.easeInOut,
      onComplete: this.moveY.bind(this),
      onCompleteParams: [target, direction * -1, randomY, randomTime],
    })
  }

  random(min, max) {
    const delta = max - min
    return (direction = 1) => (min + delta * Math.random()) * direction
  }
}
